import { CustomDateZodSchema } from '#shared/date.model.js';
import { DATE_LOOKER_PERIODS, KPI_SCOPE_FILTERS, LOOKER_PERIODS, NIELSEN_LOOKER_PERIOD, PRODUCT_TAXONOMIES, STORE_PERIMETERS } from '#shared/kpis-perimeter.model.js';
import z from 'zod';
import { ComparisonPeriodSchema, DetentionPeriodValueType, NielsenIntervalSchema, PERIOD_EVOLUTIONS } from '../period/index.js';
import { DYNAMIC_CLIENT_CATMAN_KPIS, DYNAMIC_CLIENT_DATA_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_DECOMPOSITION_CATMAN_KPIS, DYNAMIC_CLIENT_DECOMPOSITION_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_DECOMPOSITION_KPI_MAPPING, DYNAMIC_CLIENT_DECOMPOSITION_TABLE_CATMAN_KPIS, DYNAMIC_CLIENT_DECOMPOSITION_TABLE_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_DECOMPOSITION_TABLE_KPI_MAPPING, DYNAMIC_CLIENT_DYNAMICS_CATMAN_KPIS, DYNAMIC_CLIENT_DYNAMICS_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_DYNAMICS_KPI_MAPPING, DYNAMIC_CLIENT_EVOLUTION_CATMAN_KPIS, DYNAMIC_CLIENT_EVOLUTION_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_EVOLUTION_KPI_MAPPING, DYNAMIC_CLIENT_KPI_DISPLAY_NAME, DYNAMIC_CLIENT_KPI_MAPPING } from './dynamicClient/index.js';
export const CATMAN_KPIS = [
    // Sales Amount
    'sales_amount',
    'sales_amount_evolution',
    'sales_amount_with_promo',
    'sales_amount_with_promo_evolution',
    'sales_amount_without_promo',
    'sales_amount_without_promo_evolution',
    'sales_amount_promo_percent',
    'sales_amount_promo_percent_evolution',
    'cardholder_sales_amount',
    'cardholder_sales_amount_evolution',
    'non_cardholder_sales_amount',
    'non_cardholder_sales_amount_evolution',
    // Sales Quantity
    'sales_quantity',
    'sales_quantity_evolution',
    'sales_quantity_with_promo',
    'sales_quantity_with_promo_evolution',
    'sales_quantity_without_promo',
    'sales_quantity_without_promo_evolution',
    'sales_quantity_promo_percent',
    'sales_quantity_promo_percent_evolution',
    // Average Price
    'average_price',
    'average_price_evolution',
    'average_price_with_promo',
    'average_price_with_promo_evolution',
    'average_price_without_promo',
    'average_price_without_promo_evolution',
    'cardholder_average_price',
    'cardholder_average_price_evolution',
    'non_cardholder_average_price',
    'non_cardholder_average_price_evolution',
    // Average Sales
    'average_weekly_sales_amount',
    'average_weekly_sales_amount_evolution',
    'average_weekly_sales_quantity',
    'average_weekly_sales_quantity_evolution',
    // Distribution
    'numerical_distribution',
    'numerical_distribution_evolution',
    'weighted_distribution',
    'weighted_distribution_evolution',
    // Supplier/Nielsen Market Share
    'supplier_market_share_sales_amount',
    'supplier_market_share_sales_amount_evolution',
    'supplier_market_share_sales_quantity',
    'supplier_market_share_sales_quantity_evolution',
    'nielsen_market_share_sales_amount',
    'nielsen_market_share_sales_amount_evolution',
    'nielsen_market_share_sales_quantity',
    'nielsen_market_share_sales_quantity_evolution',
    // Service rate
    'service_level_rate',
    'service_level_rate_evolution',
    // Stock
    'stock_quantity',
    'stock_quantity_evolution',
    'stock_value',
    'stock_value_evolution',
    // Possession rate
    'possession_rate',
    'possession_rate_evolution',
    'nb_references_held',
    'nb_references_held_evolution',
    'nb_references_held_theoric',
    'nb_references_not_held',
    'nb_stores_holders',
    'nb_stores_holders_evolution',
    'nb_stores_holders_theoric',
    'nb_stores_non_holders',
    'depicked',
    'in_stock_no_sales',
    'out_of_stock_no_sales',
    // Transactions
    'nb_transactions',
    'nb_transactions_evolution',
    'non_cardholder_nb_transactions',
    'non_cardholder_nb_transactions_evolution',
    // Average basket
    'average_basket_in_value',
    'average_basket_in_value_evolution',
    'average_basket_in_unit',
    'average_basket_in_unit_evolution',
    'non_cardholder_average_basket_in_value',
    'non_cardholder_average_basket_in_value_evolution',
    'non_cardholder_average_basket_in_unit',
    'non_cardholder_average_basket_in_unit_evolution',
    'cardholder_average_basket_in_value',
    'cardholder_average_basket_in_value_evolution',
    'cardholder_average_basket_in_unit',
    'cardholder_average_basket_in_unit_evolution',
    // Number of cardholders
    'nb_cardholders',
    'nb_cardholders_evolution',
    // Carrefour market sales
    'carrefour_market_sales_amount',
    'carrefour_market_sales_amount_evolution',
    // Frequency
    'cardholder_frequency',
    'cardholder_frequency_evolution',
    // Sales by customers
    'cardholder_sales_by_customer',
    'cardholder_sales_by_customer_evolution',
    // Banner
    'bcp_chain_desc',
    // Competitor
    'supplier_root_key',
    'supplier_root_desc',
    'supplier_root_key_anonymized',
    'supplier_root_desc_anonymized',
    'competitor_key',
    'competitor_desc',
    'competitor_key_anonymized',
    'competitor_desc_anonymized',
    'item_key_anonymized',
    'competitor_sales_amount',
    'competitor_sales_amount_evolution',
    'competitor_sales_amount_with_promo',
    'competitor_sales_amount_with_promo_evolution',
    'competitor_sales_amount_without_promo',
    'competitor_sales_amount_without_promo_evolution',
    'competitor_sales_amount_promo_percent',
    'competitor_sales_amount_promo_percent_evolution',
    // Competitor Sales Quantity
    'competitor_sales_quantity',
    'competitor_sales_quantity_evolution',
    'competitor_sales_quantity_with_promo',
    'competitor_sales_quantity_with_promo_evolution',
    'competitor_sales_quantity_without_promo',
    'competitor_sales_quantity_without_promo_evolution',
    'competitor_sales_quantity_promo_percent',
    'competitor_sales_quantity_promo_percent_evolution',
    // Competitor DN DV
    'competitor_numerical_distribution',
    'competitor_numerical_distribution_evolution',
    'competitor_weighted_distribution',
    'competitor_weighted_distribution_evolution',
    // Competitor market share
    'competitor_supplier_market_share_sales_amount',
    'competitor_supplier_market_share_sales_amount_comparison',
    'competitor_supplier_market_share_sales_quantity',
    'competitor_supplier_market_share_sales_quantity_comparison',
    // Like for Like
    'is_eligible', //  ⚠️ This is not really a KPI, but it's used to retrieved available stores in a LikeForLike perimeter ⚠️
    'store_open_days_percent', //  ⚠️ This is not really a KPI, but it's used to retrieved information about closed stores duration in a LikeForLike perimeter ⚠️
    ...DYNAMIC_CLIENT_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_EVOLUTION_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_DECOMPOSITION_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_DECOMPOSITION_TABLE_CATMAN_KPIS,
    ...DYNAMIC_CLIENT_DYNAMICS_CATMAN_KPIS,
    // Customer Segmentation
    'cardholder_nb_transactions',
    'cardholder_nb_transactions_previous',
    'cardholder_sales_quantity_evolution',
    'cardholder_nb_transactions_evolution',
    'cardholder_average_basket_in_value',
    'cardholder_average_basket_in_value_evolution',
    'cardholder_average_basket_in_unit',
    'cardholder_average_basket_in_unit_evolution',
    'cardholder_average_price',
    'cardholder_average_price_evolution',
    'trad_consostyle_macro_desc',
    'trad_consostyle_micro_desc',
    'consostyle_macro_key',
    'consostyle_micro_key',
    'not_in_consostyle_micro_key',
    'trad_consostyle_micro_distribution',
    'trad_consostyle_macro_distribution',
    'not_in_trad_consostyle_micro_distribution',
    'not_in_trad_consostyle_macro_distribution',
    'trad_lifestage_macro_desc',
    'trad_lifestage_micro_desc',
    'lifestage_macro_key',
    'lifestage_micro_key',
    'not_in_lifestage_micro_key',
    'trad_lifestage_micro_distribution',
    'trad_lifestage_macro_distribution',
    'not_in_trad_lifestage_micro_distribution',
    'not_in_trad_lifestage_macro_distribution',
    // Customer Segmentation Donut graph : Volume by segment
    'cardholder_sales_amount_by_segment',
    'cardholder_sales_amount_by_segment_evolution',
    'cardholder_sales_amount_by_segment_previous',
    'cardholder_sales_quantity_by_segment',
    'cardholder_sales_quantity_by_segment_evolution',
    'cardholder_sales_quantity_by_segment_previous',
    'nb_cardholders_by_segment',
    'nb_cardholders_by_segment_evolution',
    'nb_cardholders_by_segment_previous',
    // Customer Segmentation per-segment layer: value delta + weight triad (donut/bar/line-badges/DataTable)
    'cardholder_sales_amount_by_segment_delta',
    'cardholder_sales_amount_weight_by_segment',
    'cardholder_sales_amount_weight_by_segment_previous',
    'cardholder_sales_amount_weight_by_segment_delta',
    'cardholder_sales_quantity_by_segment_delta',
    'cardholder_sales_quantity_weight_by_segment',
    'cardholder_sales_quantity_weight_by_segment_previous',
    'cardholder_sales_quantity_weight_by_segment_delta',
    'nb_cardholders_by_segment_delta',
    'nb_cardholders_weight_by_segment',
    'nb_cardholders_weight_by_segment_previous',
    'nb_cardholders_weight_by_segment_delta',
    // Customer Segmentation datatable Part columns: windowed weights, global-total denominator
    'cardholder_sales_amount_weight_by_segment_datatable',
    'cardholder_sales_amount_weight_by_segment_datatable_delta',
    'cardholder_sales_quantity_weight_by_segment_datatable',
    'cardholder_sales_quantity_weight_by_segment_datatable_delta',
    'nb_cardholders_weight_by_segment_datatable',
    'nb_cardholders_weight_by_segment_datatable_delta'
];
// Kpi names used in the frontend (send by the bff)
export const KPI_DISPLAY_NAME = [
    'sales_amount',
    'sales_amount_comparison',
    'sales_amount_benchmark',
    'sales_amount_without_promo',
    'sales_amount_without_promo_comparison',
    'sales_amount_without_promo_benchmark',
    'sales_amount_with_promo',
    'sales_amount_with_promo_comparison',
    'sales_amount_with_promo_benchmark',
    'sales_amount_promo_percent',
    'sales_amount_promo_percent_comparison',
    'sales_amount_promo_percent_benchmark',
    'sales_amount_cardholders',
    'sales_amount_cardholders_comparison',
    'sales_amount_cardholders_benchmark',
    'sales_amount_non_cardholders',
    'sales_amount_non_cardholders_comparison',
    'sales_amount_non_cardholders_benchmark',
    'sales_quantity',
    'sales_quantity_comparison',
    'sales_quantity_benchmark',
    'sales_quantity_without_promo',
    'sales_quantity_without_promo_comparison',
    'sales_quantity_without_promo_benchmark',
    'sales_quantity_with_promo',
    'sales_quantity_with_promo_comparison',
    'sales_quantity_with_promo_benchmark',
    'sales_quantity_promo_percent',
    'sales_quantity_promo_percent_comparison',
    'sales_quantity_promo_percent_benchmark',
    'average_weekly_sales_amount',
    'average_weekly_sales_amount_comparison',
    'average_weekly_sales_amount_benchmark',
    'average_weekly_sales_quantity',
    'average_weekly_sales_quantity_comparison',
    'average_weekly_sales_quantity_benchmark',
    'average_price',
    'average_price_comparison',
    'average_price_benchmark',
    'average_price_with_promo',
    'average_price_with_promo_comparison',
    'average_price_with_promo_benchmark',
    'gross_service_rate_downstream',
    'gross_service_rate_downstream_comparison',
    'gross_service_rate_upstream',
    'gross_service_rate_upstream_comparison',
    'net_service_rate_downstream',
    'net_service_rate_downstream_comparison',
    'net_service_rate_upstream',
    'net_service_rate_upstream_comparison',
    'nielsen_market_share_sales_amount',
    'nielsen_market_share_sales_amount_comparison',
    'nielsen_market_share_sales_quantity',
    'nielsen_market_share_sales_quantity_comparison',
    'numerical_distribution',
    'numerical_distribution_comparison',
    'sales_possession_rate',
    'sales_possession_rate_comparison',
    'number_of_references_held',
    'number_of_references_held_comparison',
    'number_of_references_held_theoretical',
    'number_of_references_not_held',
    'number_of_holder_stores',
    'number_of_holder_stores_comparison',
    'number_of_holder_stores_theoretical',
    'number_of_non_holder_stores',
    'non_possession_depicked',
    'non_possession_in_stock_no_sales',
    'non_possession_out_of_stock_no_sales',
    'store_stock_quantity',
    'store_stock_quantity_comparison',
    'store_stock_value',
    'store_stock_value_comparison',
    'supplier_market_share_sales_amount',
    'supplier_market_share_sales_amount_comparison',
    'supplier_market_share_sales_quantity',
    'supplier_market_share_sales_quantity_comparison',
    'total_stock_quantity',
    'total_stock_quantity_comparison',
    'total_stock_value',
    'total_stock_value_comparison',
    'warehouse_stock_quantity',
    'warehouse_stock_quantity_comparison',
    'warehouse_stock_value',
    'warehouse_stock_value_comparison',
    'weighted_distribution',
    'weighted_distribution_comparison',
    'number_of_transactions',
    'number_of_transactions_comparison',
    'number_of_transactions_benchmark',
    'number_of_transactions_non_cardholders',
    'number_of_transactions_non_cardholders_comparison',
    'number_of_transactions_non_cardholders_benchmark',
    'average_basket_amount',
    'average_basket_amount_comparison',
    'average_basket_amount_benchmark',
    'average_basket_amount_non_cardholders',
    'average_basket_amount_non_cardholders_comparison',
    'average_basket_amount_non_cardholders_benchmark',
    'average_basket_amount_cardholders',
    'average_basket_amount_cardholders_comparison',
    'average_basket_amount_cardholders_benchmark',
    'average_basket_quantity',
    'average_basket_quantity_comparison',
    'average_basket_quantity_benchmark',
    'average_basket_quantity_non_cardholders',
    'average_basket_quantity_non_cardholders_comparison',
    'average_basket_quantity_non_cardholders_benchmark',
    'average_basket_quantity_cardholders',
    'average_basket_quantity_cardholders_comparison',
    'average_basket_quantity_cardholders_benchmark',
    'average_price_non_cardholders',
    'average_price_non_cardholders_comparison',
    'average_price_non_cardholders_benchmark',
    'average_price_cardholders',
    'average_price_cardholders_comparison',
    'average_price_cardholders_benchmark',
    'carrefour_market_sales',
    'carrefour_market_sales_comparison',
    'number_of_cardholders',
    'number_of_cardholders_comparison',
    'number_of_cardholders_benchmark',
    'frequency_cardholders',
    'frequency_cardholders_comparison',
    'frequency_cardholders_benchmark',
    'sales_by_customer_cardholders',
    'sales_by_customer_cardholders_comparison',
    'sales_by_customer_cardholders_benchmark',
    'bcp_chain_desc',
    // Competitor
    'supplier_root_key_anonymized',
    'supplier_root_desc_anonymized',
    'competitor_key_anonymized',
    'competitor_desc_anonymized',
    'item_key_anonymized',
    'competitor_supplier_root_key',
    'competitor_supplier_root_desc',
    'competitor_sales_amount',
    'competitor_sales_amount_comparison',
    'competitor_sales_amount_without_promo',
    'competitor_sales_amount_without_promo_comparison',
    'competitor_sales_amount_with_promo',
    'competitor_sales_amount_with_promo_comparison',
    'competitor_sales_amount_promo_percent',
    'competitor_sales_amount_promo_percent_comparison',
    'competitor_sales_amount_promo_percent_benchmark',
    'competitor_sales_quantity',
    'competitor_sales_quantity_comparison',
    'competitor_sales_quantity_without_promo',
    'competitor_sales_quantity_without_promo_comparison',
    'competitor_sales_quantity_with_promo',
    'competitor_sales_quantity_with_promo_comparison',
    'competitor_sales_quantity_promo_percent',
    'competitor_sales_quantity_promo_percent_comparison',
    'competitor_average_weekly_sales_amount',
    'competitor_average_weekly_sales_amount_comparison',
    'competitor_average_weekly_sales_quantity',
    'competitor_average_weekly_sales_quantity_comparison',
    'competitor_numerical_distribution',
    'competitor_numerical_distribution_evolution',
    'competitor_weighted_distribution',
    'competitor_weighted_distribution_evolution',
    'competitor_supplier_market_share_sales_amount',
    'competitor_supplier_market_share_sales_amount_comparison',
    'competitor_supplier_market_share_sales_quantity',
    'competitor_supplier_market_share_sales_quantity_comparison',
    // Like for Like
    'is_eligible', //  ⚠️ This is not really a KPI, but it's used to retrieved available stores in a LikeForLike perimeter ⚠️
    'store_open_days_percent', //  ⚠️ This is not really a KPI, but it's used to retrieved information about closed stores duration in a LikeForLike perimeter ⚠️
    ...DYNAMIC_CLIENT_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_EVOLUTION_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_DECOMPOSITION_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_DECOMPOSITION_TABLE_KPI_DISPLAY_NAME,
    ...DYNAMIC_CLIENT_DYNAMICS_KPI_DISPLAY_NAME,
    // Customer Segmentation
    'number_of_transactions_cardholders',
    'customer_segmentation_cardholder_sales_amount',
    'customer_segmentation_cardholder_sales_amount_share',
    'customer_segmentation_sales_amount',
    'customer_segmentation_cardholder_sales_by_customer',
    'customer_segmentation_cardholder_sales_quantity',
    'customer_segmentation_cardholder_sales_quantity_share',
    'customer_segmentation_nb_cardholders',
    'customer_segmentation_nb_cardholders_share',
    'customer_segmentation_cardholder_nb_transactions',
    'customer_segmentation_cardholder_sales_per_customer',
    'customer_segmentation_cardholder_sales_amount_evolution',
    'customer_segmentation_cardholder_sales_by_customer_evolution',
    'customer_segmentation_cardholder_sales_per_customer_evolution',
    'customer_segmentation_cardholder_sales_quantity_evolution',
    'customer_segmentation_nb_cardholders_evolution',
    'customer_segmentation_cardholder_nb_transactions_evolution',
    'customer_segmentation_cardholder_sales_amount_with_promo',
    'customer_segmentation_cardholder_sales_amount_without_promo',
    'customer_segmentation_cardholder_sales_amount_with_promo_evolution',
    'customer_segmentation_cardholder_sales_amount_without_promo_evolution',
    'customer_segmentation_cardholder_sales_quantity_with_promo',
    'customer_segmentation_cardholder_sales_quantity_without_promo',
    'customer_segmentation_cardholder_sales_quantity_with_promo_evolution',
    'customer_segmentation_cardholder_sales_quantity_without_promo_evolution',
    'customer_segmentation_cardholder_sales_amount_previous',
    'customer_segmentation_cardholder_sales_quantity_previous',
    'customer_segmentation_nb_cardholders_previous',
    'customer_segmentation_cardholder_nb_transactions_previous',
    'customer_segmentation_cardholder_frequency',
    'customer_segmentation_cardholder_frequency_evolution',
    'customer_segmentation_cardholder_average_basket_in_value',
    'customer_segmentation_cardholder_average_basket_in_value_evolution',
    'customer_segmentation_cardholder_average_basket_in_unit',
    'customer_segmentation_cardholder_average_basket_in_unit_evolution',
    'customer_segmentation_cardholder_average_price',
    'customer_segmentation_cardholder_average_price_evolution',
    'customer_segmentation_cardholder_sales_amount_with_promo_previous',
    'customer_segmentation_cardholder_sales_amount_without_promo_previous',
    'customer_segmentation_cardholder_sales_quantity_with_promo_previous',
    'customer_segmentation_cardholder_sales_quantity_without_promo_previous',
    'customer_segmentation_cardholder_sales_amount_comparison',
    'customer_segmentation_cardholder_sales_amount_with_promo_comparison',
    'customer_segmentation_cardholder_sales_amount_without_promo_comparison',
    'customer_segmentation_cardholder_sales_quantity_comparison',
    'customer_segmentation_cardholder_sales_quantity_with_promo_comparison',
    'customer_segmentation_cardholder_sales_quantity_without_promo_comparison',
    'customer_segmentation_nb_cardholders_comparison',
    'customer_segmentation_cardholder_nb_transactions_comparison',
    'customer_segmentation_cardholder_sales_per_customer_comparison',
    'customer_segmentation_cardholder_frequency_comparison',
    'customer_segmentation_cardholder_average_basket_in_value_comparison',
    'customer_segmentation_cardholder_average_basket_in_unit_comparison',
    'customer_segmentation_cardholder_average_price_comparison',
    'customer_segmentation_trad_consostyle_macro_desc',
    'customer_segmentation_trad_consostyle_micro_desc',
    'customer_segmentation_consostyle_macro_key',
    'customer_segmentation_consostyle_micro_key',
    'customer_segmentation_trad_lifestage_macro_desc',
    'customer_segmentation_trad_lifestage_micro_desc',
    'customer_segmentation_lifestage_macro_key',
    'customer_segmentation_lifestage_micro_key',
    // Customer Segmentation Donut graph : Volume by segment
    'customer_segmentation_cardholder_sales_amount_by_segment',
    'customer_segmentation_cardholder_sales_amount_by_segment_comparison',
    'customer_segmentation_cardholder_sales_amount_by_segment_previous',
    'customer_segmentation_cardholder_sales_quantity_by_segment',
    'customer_segmentation_cardholder_sales_quantity_by_segment_comparison',
    'customer_segmentation_cardholder_sales_quantity_by_segment_previous',
    'customer_segmentation_nb_cardholders_by_segment',
    'customer_segmentation_nb_cardholders_by_segment_comparison',
    'customer_segmentation_nb_cardholders_by_segment_previous',
    // Customer Segmentation per-segment layer: value delta + weight triad (donut/bar/line-badges/DataTable)
    'customer_segmentation_cardholder_sales_amount_by_segment_delta',
    'customer_segmentation_cardholder_sales_amount_weight_by_segment',
    'customer_segmentation_cardholder_sales_amount_weight_by_segment_previous',
    'customer_segmentation_cardholder_sales_amount_weight_by_segment_delta',
    'customer_segmentation_cardholder_sales_quantity_by_segment_delta',
    'customer_segmentation_cardholder_sales_quantity_weight_by_segment',
    'customer_segmentation_cardholder_sales_quantity_weight_by_segment_previous',
    'customer_segmentation_cardholder_sales_quantity_weight_by_segment_delta',
    'customer_segmentation_nb_cardholders_by_segment_delta',
    'customer_segmentation_nb_cardholders_weight_by_segment',
    'customer_segmentation_nb_cardholders_weight_by_segment_previous',
    'customer_segmentation_nb_cardholders_weight_by_segment_delta',
    // Customer Segmentation datatable Part columns: windowed weights, global-total denominator
    'customer_segmentation_cardholder_sales_amount_weight_by_segment_datatable',
    'customer_segmentation_cardholder_sales_amount_weight_by_segment_datatable_delta',
    'customer_segmentation_cardholder_sales_quantity_weight_by_segment_datatable',
    'customer_segmentation_cardholder_sales_quantity_weight_by_segment_datatable_delta',
    'customer_segmentation_nb_cardholders_weight_by_segment_datatable',
    'customer_segmentation_nb_cardholders_weight_by_segment_datatable_delta'
];
export const CUSTOMER_SEGMENTATION_DIMENSION = {
    CONSOSTYLE_MACRO_DESC: 'customer_segmentation_trad_consostyle_macro_desc',
    CONSOSTYLE_MICRO_DESC: 'customer_segmentation_trad_consostyle_micro_desc',
    CONSOSTYLE_MACRO_KEY: 'customer_segmentation_consostyle_macro_key',
    CONSOSTYLE_MICRO_KEY: 'customer_segmentation_consostyle_micro_key',
    LIFESTAGE_MACRO_DESC: 'customer_segmentation_trad_lifestage_macro_desc',
    LIFESTAGE_MICRO_DESC: 'customer_segmentation_trad_lifestage_micro_desc',
    LIFESTAGE_MACRO_KEY: 'customer_segmentation_lifestage_macro_key',
    LIFESTAGE_MICRO_KEY: 'customer_segmentation_lifestage_micro_key',
    NB_CARDHOLDERS: 'customer_segmentation_nb_cardholders',
    NB_CARDHOLDERS_EVOLUTION: 'customer_segmentation_nb_cardholders_evolution',
    SALES_AMOUNT: 'customer_segmentation_sales_amount',
    CARDHOLDER_SALES_AMOUNT: 'customer_segmentation_cardholder_sales_amount',
    CARDHOLDER_SALES_AMOUNT_EVOLUTION: 'customer_segmentation_cardholder_sales_amount_evolution',
    CARDHOLDER_SALES_QUANTITY: 'customer_segmentation_cardholder_sales_quantity',
    CARDHOLDER_SALES_QUANTITY_EVOLUTION: 'customer_segmentation_cardholder_sales_quantity_evolution'
};
export const KpiDisplayNameToKpiName = {
    sales_amount: 'sales_amount',
    sales_amount_comparison: 'sales_amount_evolution',
    sales_amount_benchmark: 'sales_amount_evolution',
    sales_amount_without_promo: 'sales_amount_without_promo',
    sales_amount_without_promo_comparison: 'sales_amount_without_promo_evolution',
    sales_amount_without_promo_benchmark: 'sales_amount_without_promo_evolution',
    sales_amount_with_promo: 'sales_amount_with_promo',
    sales_amount_with_promo_comparison: 'sales_amount_with_promo_evolution',
    sales_amount_with_promo_benchmark: 'sales_amount_with_promo_evolution',
    sales_amount_promo_percent: 'sales_amount_promo_percent',
    sales_amount_promo_percent_comparison: 'sales_amount_promo_percent_evolution',
    sales_amount_promo_percent_benchmark: 'sales_amount_promo_percent_evolution',
    sales_amount_cardholders: 'cardholder_sales_amount',
    sales_amount_cardholders_comparison: 'cardholder_sales_amount_evolution',
    sales_amount_cardholders_benchmark: 'cardholder_sales_amount_evolution',
    sales_amount_non_cardholders: 'non_cardholder_sales_amount',
    sales_amount_non_cardholders_comparison: 'non_cardholder_sales_amount_evolution',
    sales_amount_non_cardholders_benchmark: 'non_cardholder_sales_amount_evolution',
    sales_quantity: 'sales_quantity',
    sales_quantity_comparison: 'sales_quantity_evolution',
    sales_quantity_benchmark: 'sales_quantity_evolution',
    sales_quantity_without_promo: 'sales_quantity_without_promo',
    sales_quantity_without_promo_comparison: 'sales_quantity_without_promo_evolution',
    sales_quantity_without_promo_benchmark: 'sales_quantity_without_promo_evolution',
    sales_quantity_with_promo: 'sales_quantity_with_promo',
    sales_quantity_with_promo_comparison: 'sales_quantity_with_promo_evolution',
    sales_quantity_with_promo_benchmark: 'sales_quantity_with_promo_evolution',
    sales_quantity_promo_percent: 'sales_quantity_promo_percent',
    sales_quantity_promo_percent_comparison: 'sales_quantity_promo_percent_evolution',
    sales_quantity_promo_percent_benchmark: 'sales_quantity_promo_percent_evolution',
    average_weekly_sales_amount: 'average_weekly_sales_amount',
    average_weekly_sales_amount_comparison: 'average_weekly_sales_amount_evolution',
    average_weekly_sales_amount_benchmark: 'average_weekly_sales_amount_evolution',
    average_weekly_sales_quantity: 'average_weekly_sales_quantity',
    average_weekly_sales_quantity_comparison: 'average_weekly_sales_quantity_evolution',
    average_weekly_sales_quantity_benchmark: 'average_weekly_sales_quantity_evolution',
    average_price: 'average_price',
    average_price_comparison: 'average_price_evolution',
    average_price_benchmark: 'average_price_evolution',
    average_price_with_promo: 'average_price_with_promo',
    average_price_with_promo_comparison: 'average_price_with_promo_evolution',
    average_price_with_promo_benchmark: 'average_price_with_promo_evolution',
    average_price_cardholders: 'cardholder_average_price',
    average_price_cardholders_comparison: 'cardholder_average_price_evolution',
    average_price_cardholders_benchmark: 'cardholder_average_price_evolution',
    average_price_non_cardholders: 'non_cardholder_average_price',
    average_price_non_cardholders_comparison: 'non_cardholder_average_price_evolution',
    average_price_non_cardholders_benchmark: 'non_cardholder_average_price_evolution',
    gross_service_rate_downstream: 'service_level_rate',
    gross_service_rate_downstream_comparison: 'service_level_rate_evolution',
    gross_service_rate_upstream: 'service_level_rate',
    gross_service_rate_upstream_comparison: 'service_level_rate_evolution',
    net_service_rate_downstream: 'service_level_rate',
    net_service_rate_downstream_comparison: 'service_level_rate_evolution',
    net_service_rate_upstream: 'service_level_rate',
    net_service_rate_upstream_comparison: 'service_level_rate_evolution',
    nielsen_market_share_sales_amount: 'nielsen_market_share_sales_amount',
    nielsen_market_share_sales_amount_comparison: 'nielsen_market_share_sales_amount_evolution',
    nielsen_market_share_sales_quantity: 'nielsen_market_share_sales_quantity',
    nielsen_market_share_sales_quantity_comparison: 'nielsen_market_share_sales_quantity_evolution',
    numerical_distribution: 'numerical_distribution',
    numerical_distribution_comparison: 'numerical_distribution_evolution',
    sales_possession_rate: 'possession_rate',
    sales_possession_rate_comparison: 'possession_rate_evolution',
    number_of_references_held: 'nb_references_held',
    number_of_references_held_comparison: 'nb_references_held_evolution',
    number_of_references_held_theoretical: 'nb_references_held_theoric',
    number_of_references_not_held: 'nb_references_not_held',
    number_of_holder_stores: 'nb_stores_holders',
    number_of_holder_stores_comparison: 'nb_stores_holders_evolution',
    number_of_holder_stores_theoretical: 'nb_stores_holders_theoric',
    number_of_non_holder_stores: 'nb_stores_non_holders',
    non_possession_depicked: 'depicked',
    non_possession_in_stock_no_sales: 'in_stock_no_sales',
    non_possession_out_of_stock_no_sales: 'out_of_stock_no_sales',
    store_stock_quantity: 'stock_quantity',
    store_stock_quantity_comparison: 'stock_quantity_evolution',
    store_stock_value: 'stock_value',
    store_stock_value_comparison: 'stock_value_evolution',
    supplier_market_share_sales_amount: 'supplier_market_share_sales_amount',
    supplier_market_share_sales_amount_comparison: 'supplier_market_share_sales_amount_evolution',
    supplier_market_share_sales_quantity: 'supplier_market_share_sales_quantity',
    supplier_market_share_sales_quantity_comparison: 'supplier_market_share_sales_quantity_evolution',
    total_stock_quantity: 'stock_quantity',
    total_stock_quantity_comparison: 'stock_quantity_evolution',
    total_stock_value: 'stock_value',
    total_stock_value_comparison: 'stock_value_evolution',
    warehouse_stock_quantity: 'stock_quantity',
    warehouse_stock_quantity_comparison: 'stock_quantity_evolution',
    warehouse_stock_value: 'stock_value',
    warehouse_stock_value_comparison: 'stock_value_evolution',
    weighted_distribution: 'weighted_distribution',
    weighted_distribution_comparison: 'weighted_distribution_evolution',
    number_of_transactions: 'nb_transactions',
    number_of_transactions_comparison: 'nb_transactions_evolution',
    number_of_transactions_benchmark: 'nb_transactions_evolution',
    number_of_transactions_non_cardholders: 'non_cardholder_nb_transactions',
    number_of_transactions_non_cardholders_comparison: 'non_cardholder_nb_transactions_evolution',
    number_of_transactions_non_cardholders_benchmark: 'non_cardholder_nb_transactions_evolution',
    average_basket_amount: 'average_basket_in_value',
    average_basket_amount_comparison: 'average_basket_in_value_evolution',
    average_basket_amount_benchmark: 'average_basket_in_value_evolution',
    average_basket_amount_non_cardholders: 'non_cardholder_average_basket_in_value',
    average_basket_amount_non_cardholders_comparison: 'non_cardholder_average_basket_in_value_evolution',
    average_basket_amount_non_cardholders_benchmark: 'non_cardholder_average_basket_in_value_evolution',
    average_basket_amount_cardholders: 'cardholder_average_basket_in_value',
    average_basket_amount_cardholders_comparison: 'cardholder_average_basket_in_value_evolution',
    average_basket_amount_cardholders_benchmark: 'cardholder_average_basket_in_value_evolution',
    average_basket_quantity: 'average_basket_in_unit',
    average_basket_quantity_comparison: 'average_basket_in_unit_evolution',
    average_basket_quantity_benchmark: 'average_basket_in_unit_evolution',
    average_basket_quantity_non_cardholders: 'non_cardholder_average_basket_in_unit',
    average_basket_quantity_non_cardholders_comparison: 'non_cardholder_average_basket_in_unit_evolution',
    average_basket_quantity_non_cardholders_benchmark: 'non_cardholder_average_basket_in_unit_evolution',
    average_basket_quantity_cardholders: 'cardholder_average_basket_in_unit',
    average_basket_quantity_cardholders_comparison: 'cardholder_average_basket_in_unit_evolution',
    average_basket_quantity_cardholders_benchmark: 'cardholder_average_basket_in_unit_evolution',
    carrefour_market_sales: 'carrefour_market_sales_amount',
    carrefour_market_sales_comparison: 'carrefour_market_sales_amount_evolution',
    number_of_cardholders: 'nb_cardholders',
    number_of_cardholders_comparison: 'nb_cardholders_evolution',
    number_of_cardholders_benchmark: 'nb_cardholders_evolution',
    frequency_cardholders: 'cardholder_frequency',
    frequency_cardholders_comparison: 'cardholder_frequency_evolution',
    frequency_cardholders_benchmark: 'cardholder_frequency_evolution',
    sales_by_customer_cardholders: 'cardholder_sales_by_customer',
    sales_by_customer_cardholders_comparison: 'cardholder_sales_by_customer_evolution',
    sales_by_customer_cardholders_benchmark: 'cardholder_sales_by_customer_evolution',
    bcp_chain_desc: 'bcp_chain_desc',
    supplier_root_key_anonymized: 'supplier_root_key_anonymized',
    supplier_root_desc_anonymized: 'supplier_root_desc_anonymized',
    competitor_key_anonymized: 'competitor_key_anonymized',
    competitor_desc_anonymized: 'competitor_desc_anonymized',
    item_key_anonymized: 'item_key_anonymized',
    competitor_supplier_root_key: 'competitor_key',
    competitor_supplier_root_desc: 'competitor_desc',
    competitor_sales_amount: 'sales_amount',
    competitor_sales_amount_comparison: 'sales_amount_evolution',
    competitor_sales_amount_without_promo: 'sales_amount_without_promo',
    competitor_sales_amount_without_promo_comparison: 'sales_amount_without_promo_evolution',
    competitor_sales_amount_with_promo: 'sales_amount_with_promo',
    competitor_sales_amount_with_promo_comparison: 'sales_amount_with_promo_evolution',
    competitor_sales_amount_promo_percent: 'sales_amount_promo_percent',
    competitor_sales_amount_promo_percent_comparison: 'sales_amount_promo_percent_evolution',
    competitor_sales_amount_promo_percent_benchmark: 'sales_amount_promo_percent_evolution',
    competitor_sales_quantity: 'sales_quantity',
    competitor_sales_quantity_comparison: 'sales_quantity_evolution',
    competitor_sales_quantity_without_promo: 'sales_quantity_without_promo',
    competitor_sales_quantity_without_promo_comparison: 'sales_quantity_without_promo_evolution',
    competitor_sales_quantity_with_promo: 'sales_quantity_with_promo',
    competitor_sales_quantity_with_promo_comparison: 'sales_quantity_with_promo_evolution',
    competitor_sales_quantity_promo_percent: 'sales_quantity_promo_percent',
    competitor_sales_quantity_promo_percent_comparison: 'sales_quantity_promo_percent_evolution',
    competitor_average_weekly_sales_amount: 'average_weekly_sales_amount',
    competitor_average_weekly_sales_amount_comparison: 'average_weekly_sales_amount_evolution',
    competitor_average_weekly_sales_quantity: 'average_weekly_sales_quantity',
    competitor_average_weekly_sales_quantity_comparison: 'average_weekly_sales_quantity_evolution',
    competitor_numerical_distribution: 'numerical_distribution',
    competitor_numerical_distribution_evolution: 'numerical_distribution_evolution',
    competitor_weighted_distribution: 'weighted_distribution',
    competitor_weighted_distribution_evolution: 'weighted_distribution_evolution',
    competitor_supplier_market_share_sales_amount: 'supplier_market_share_sales_amount',
    competitor_supplier_market_share_sales_amount_comparison: 'supplier_market_share_sales_amount_evolution',
    competitor_supplier_market_share_sales_quantity: 'supplier_market_share_sales_quantity',
    competitor_supplier_market_share_sales_quantity_comparison: 'supplier_market_share_sales_quantity_evolution',
    // Like for Like
    is_eligible: 'is_eligible', //  ⚠️ This is not really a KPI, but it's used to retrieved available stores in a LikeForLike perimeter ⚠️
    store_open_days_percent: 'store_open_days_percent', //  ⚠️ This is not really a KPI, but it's used to retrieved information about closed stores duration in a LikeForLike perimeter ⚠️
    ...DYNAMIC_CLIENT_KPI_MAPPING,
    ...DYNAMIC_CLIENT_EVOLUTION_KPI_MAPPING,
    ...DYNAMIC_CLIENT_DECOMPOSITION_KPI_MAPPING,
    ...DYNAMIC_CLIENT_DECOMPOSITION_TABLE_KPI_MAPPING,
    ...DYNAMIC_CLIENT_DYNAMICS_KPI_MAPPING,
    // Customer Segmentation
    number_of_transactions_cardholders: 'cardholder_nb_transactions',
    customer_segmentation_cardholder_sales_amount: 'cardholder_sales_amount',
    customer_segmentation_cardholder_sales_amount_share: 'cardholder_sales_amount',
    customer_segmentation_sales_amount: 'sales_amount',
    customer_segmentation_cardholder_sales_by_customer: 'cardholder_sales_by_customer',
    customer_segmentation_cardholder_sales_quantity: 'cardholder_sales_quantity',
    customer_segmentation_cardholder_sales_quantity_share: 'cardholder_sales_quantity',
    customer_segmentation_nb_cardholders: 'nb_cardholders',
    customer_segmentation_nb_cardholders_share: 'nb_cardholders',
    customer_segmentation_cardholder_nb_transactions: 'cardholder_nb_transactions',
    customer_segmentation_cardholder_sales_per_customer: 'cardholder_sales_by_customer',
    customer_segmentation_cardholder_sales_amount_evolution: 'cardholder_sales_amount_evolution',
    customer_segmentation_cardholder_sales_quantity_evolution: 'cardholder_sales_quantity_evolution',
    customer_segmentation_cardholder_sales_by_customer_evolution: 'cardholder_sales_by_customer_evolution',
    customer_segmentation_cardholder_sales_per_customer_evolution: 'cardholder_sales_by_customer_evolution',
    customer_segmentation_nb_cardholders_evolution: 'nb_cardholders_evolution',
    customer_segmentation_cardholder_nb_transactions_evolution: 'cardholder_nb_transactions_evolution',
    customer_segmentation_cardholder_average_basket_in_value: 'cardholder_average_basket_in_value',
    customer_segmentation_cardholder_average_basket_in_value_evolution: 'cardholder_average_basket_in_value_evolution',
    customer_segmentation_cardholder_average_basket_in_unit: 'cardholder_average_basket_in_unit',
    customer_segmentation_cardholder_average_basket_in_unit_evolution: 'cardholder_average_basket_in_unit_evolution',
    customer_segmentation_cardholder_average_price: 'cardholder_average_price',
    customer_segmentation_cardholder_average_price_evolution: 'cardholder_average_price_evolution',
    customer_segmentation_cardholder_frequency: 'cardholder_frequency',
    customer_segmentation_cardholder_frequency_evolution: 'cardholder_frequency_evolution',
    customer_segmentation_cardholder_sales_amount_with_promo: 'cardholder_sales_amount_with_promo',
    customer_segmentation_cardholder_sales_amount_without_promo: 'cardholder_sales_amount_without_promo',
    customer_segmentation_cardholder_sales_amount_with_promo_evolution: 'cardholder_sales_amount_with_promo_evolution',
    customer_segmentation_cardholder_sales_amount_without_promo_evolution: 'cardholder_sales_amount_without_promo_evolution',
    customer_segmentation_cardholder_sales_quantity_with_promo: 'cardholder_sales_quantity_with_promo',
    customer_segmentation_cardholder_sales_quantity_without_promo: 'cardholder_sales_quantity_without_promo',
    customer_segmentation_cardholder_sales_quantity_with_promo_evolution: 'cardholder_sales_quantity_with_promo_evolution',
    customer_segmentation_cardholder_sales_quantity_without_promo_evolution: 'cardholder_sales_quantity_without_promo_evolution',
    customer_segmentation_cardholder_sales_amount_comparison: 'cardholder_sales_amount_evolution',
    customer_segmentation_cardholder_sales_amount_with_promo_comparison: 'cardholder_sales_amount_with_promo_evolution',
    customer_segmentation_cardholder_sales_amount_without_promo_comparison: 'cardholder_sales_amount_without_promo_evolution',
    customer_segmentation_cardholder_sales_quantity_comparison: 'cardholder_sales_quantity_evolution',
    customer_segmentation_cardholder_sales_quantity_with_promo_comparison: 'cardholder_sales_quantity_with_promo_evolution',
    customer_segmentation_cardholder_sales_quantity_without_promo_comparison: 'cardholder_sales_quantity_without_promo_evolution',
    customer_segmentation_nb_cardholders_comparison: 'nb_cardholders_evolution',
    customer_segmentation_cardholder_nb_transactions_comparison: 'cardholder_nb_transactions_evolution',
    customer_segmentation_cardholder_sales_per_customer_comparison: 'cardholder_sales_by_customer_evolution',
    customer_segmentation_cardholder_frequency_comparison: 'cardholder_frequency_evolution',
    customer_segmentation_cardholder_average_basket_in_value_comparison: 'cardholder_average_basket_in_value_evolution',
    customer_segmentation_cardholder_average_basket_in_unit_comparison: 'cardholder_average_basket_in_unit_evolution',
    customer_segmentation_cardholder_average_price_comparison: 'cardholder_average_price_evolution',
    customer_segmentation_cardholder_sales_amount_previous: 'cardholder_sales_amount_previous',
    customer_segmentation_cardholder_sales_quantity_previous: 'cardholder_sales_quantity_previous',
    customer_segmentation_nb_cardholders_previous: 'nb_cardholders_previous',
    customer_segmentation_cardholder_nb_transactions_previous: 'cardholder_nb_transactions_previous',
    customer_segmentation_cardholder_sales_amount_with_promo_previous: 'cardholder_sales_amount_with_promo_previous',
    customer_segmentation_cardholder_sales_amount_without_promo_previous: 'cardholder_sales_amount_without_promo_previous',
    customer_segmentation_cardholder_sales_quantity_with_promo_previous: 'cardholder_sales_quantity_with_promo_previous',
    customer_segmentation_cardholder_sales_quantity_without_promo_previous: 'cardholder_sales_quantity_without_promo_previous',
    customer_segmentation_trad_consostyle_macro_desc: 'trad_consostyle_macro_desc',
    customer_segmentation_trad_consostyle_micro_desc: 'trad_consostyle_micro_desc',
    customer_segmentation_consostyle_macro_key: 'consostyle_macro_key',
    customer_segmentation_consostyle_micro_key: 'consostyle_micro_key',
    customer_segmentation_trad_lifestage_macro_desc: 'trad_lifestage_macro_desc',
    customer_segmentation_trad_lifestage_micro_desc: 'trad_lifestage_micro_desc',
    customer_segmentation_lifestage_macro_key: 'lifestage_macro_key',
    customer_segmentation_lifestage_micro_key: 'lifestage_micro_key',
    // Customer Segmentation Donut graph : Volume by segment
    customer_segmentation_cardholder_sales_amount_by_segment: 'cardholder_sales_amount_by_segment',
    customer_segmentation_cardholder_sales_amount_by_segment_comparison: 'cardholder_sales_amount_by_segment_evolution',
    customer_segmentation_cardholder_sales_amount_by_segment_previous: 'cardholder_sales_amount_by_segment_previous',
    customer_segmentation_cardholder_sales_quantity_by_segment: 'cardholder_sales_quantity_by_segment',
    customer_segmentation_cardholder_sales_quantity_by_segment_comparison: 'cardholder_sales_quantity_by_segment_evolution',
    customer_segmentation_cardholder_sales_quantity_by_segment_previous: 'cardholder_sales_quantity_by_segment_previous',
    customer_segmentation_nb_cardholders_by_segment: 'nb_cardholders_by_segment',
    customer_segmentation_nb_cardholders_by_segment_comparison: 'nb_cardholders_by_segment_evolution',
    customer_segmentation_nb_cardholders_by_segment_previous: 'nb_cardholders_by_segment_previous',
    // Customer Segmentation per-segment layer: value delta + weight triad (donut/bar/line-badges/DataTable)
    customer_segmentation_cardholder_sales_amount_by_segment_delta: 'cardholder_sales_amount_by_segment_delta',
    customer_segmentation_cardholder_sales_amount_weight_by_segment: 'cardholder_sales_amount_weight_by_segment',
    customer_segmentation_cardholder_sales_amount_weight_by_segment_previous: 'cardholder_sales_amount_weight_by_segment_previous',
    customer_segmentation_cardholder_sales_amount_weight_by_segment_delta: 'cardholder_sales_amount_weight_by_segment_delta',
    customer_segmentation_cardholder_sales_quantity_by_segment_delta: 'cardholder_sales_quantity_by_segment_delta',
    customer_segmentation_cardholder_sales_quantity_weight_by_segment: 'cardholder_sales_quantity_weight_by_segment',
    customer_segmentation_cardholder_sales_quantity_weight_by_segment_previous: 'cardholder_sales_quantity_weight_by_segment_previous',
    customer_segmentation_cardholder_sales_quantity_weight_by_segment_delta: 'cardholder_sales_quantity_weight_by_segment_delta',
    customer_segmentation_nb_cardholders_by_segment_delta: 'nb_cardholders_by_segment_delta',
    customer_segmentation_nb_cardholders_weight_by_segment: 'nb_cardholders_weight_by_segment',
    customer_segmentation_nb_cardholders_weight_by_segment_previous: 'nb_cardholders_weight_by_segment_previous',
    customer_segmentation_nb_cardholders_weight_by_segment_delta: 'nb_cardholders_weight_by_segment_delta',
    // Customer Segmentation datatable Part columns: windowed weights, global-total denominator
    customer_segmentation_cardholder_sales_amount_weight_by_segment_datatable: 'cardholder_sales_amount_weight_by_segment_datatable',
    customer_segmentation_cardholder_sales_amount_weight_by_segment_datatable_delta: 'cardholder_sales_amount_weight_by_segment_datatable_delta',
    customer_segmentation_cardholder_sales_quantity_weight_by_segment_datatable: 'cardholder_sales_quantity_weight_by_segment_datatable',
    customer_segmentation_cardholder_sales_quantity_weight_by_segment_datatable_delta: 'cardholder_sales_quantity_weight_by_segment_datatable_delta',
    customer_segmentation_nb_cardholders_weight_by_segment_datatable: 'nb_cardholders_weight_by_segment_datatable',
    customer_segmentation_nb_cardholders_weight_by_segment_datatable_delta: 'nb_cardholders_weight_by_segment_datatable_delta'
};
export const DATA_TABLE_KPI_DISPLAY_NAME = [
    'sales_amount',
    'sales_amount_without_promo',
    'sales_amount_with_promo',
    'sales_amount_promo_percent',
    'sales_amount_cardholders',
    'sales_amount_non_cardholders',
    'sales_quantity',
    'sales_quantity_without_promo',
    'sales_quantity_with_promo',
    'sales_quantity_promo_percent',
    'number_of_transactions',
    'number_of_transactions_non_cardholders',
    'average_basket_amount',
    'average_basket_amount_cardholders',
    'average_basket_amount_non_cardholders',
    'average_basket_quantity',
    'average_basket_quantity_non_cardholders',
    'average_weekly_sales_amount',
    'average_weekly_sales_quantity',
    'average_price',
    'average_price_with_promo',
    'average_price_non_cardholders',
    'carrefour_market_sales',
    'number_of_cardholders',
    'supplier_market_share_sales_amount',
    'supplier_market_share_sales_quantity',
    'nielsen_market_share_sales_amount',
    'nielsen_market_share_sales_quantity',
    'supplier_market_share_sales_amount_comparison',
    'supplier_market_share_sales_quantity_comparison',
    'nielsen_market_share_sales_amount_comparison',
    'nielsen_market_share_sales_quantity_comparison',
    'sales_possession_rate',
    'gross_service_rate_downstream',
    'gross_service_rate_upstream',
    'net_service_rate_downstream',
    'net_service_rate_upstream',
    'warehouse_stock_value',
    'warehouse_stock_quantity',
    'store_stock_value',
    'store_stock_quantity',
    'total_stock_value',
    'total_stock_quantity',
    'frequency_cardholders',
    'sales_by_customer_cardholders',
    'number_of_references_held_theoretical',
    'number_of_references_not_held',
    'number_of_holder_stores_theoretical',
    'number_of_non_holder_stores',
    'numerical_distribution',
    'weighted_distribution',
    'bcp_chain_desc',
    'non_possession_depicked',
    'non_possession_in_stock_no_sales',
    'non_possession_out_of_stock_no_sales',
    'competitor_sales_amount',
    'competitor_sales_amount_without_promo',
    'competitor_sales_amount_with_promo',
    'competitor_sales_amount_promo_percent',
    'competitor_sales_quantity',
    'competitor_sales_quantity_without_promo',
    'competitor_sales_quantity_with_promo',
    'competitor_sales_quantity_promo_percent',
    'competitor_average_weekly_sales_amount',
    'competitor_average_weekly_sales_quantity',
    'competitor_supplier_market_share_sales_amount',
    'competitor_supplier_market_share_sales_amount_comparison',
    'competitor_supplier_market_share_sales_quantity',
    'competitor_supplier_market_share_sales_quantity_comparison',
    ...DYNAMIC_CLIENT_DATA_TABLE_KPI_DISPLAY_NAME,
    // Customer Segmentation
    'customer_segmentation_cardholder_sales_amount',
    'customer_segmentation_cardholder_sales_amount_share',
    'customer_segmentation_cardholder_sales_quantity',
    'customer_segmentation_cardholder_sales_quantity_share',
    'customer_segmentation_nb_cardholders',
    'customer_segmentation_nb_cardholders_share',
    'customer_segmentation_cardholder_nb_transactions',
    'customer_segmentation_cardholder_sales_per_customer',
    'customer_segmentation_cardholder_frequency',
    'customer_segmentation_cardholder_average_basket_in_value',
    'customer_segmentation_cardholder_average_basket_in_unit',
    'customer_segmentation_cardholder_average_price',
    'customer_segmentation_cardholder_sales_quantity_with_promo',
    'customer_segmentation_cardholder_sales_quantity_without_promo',
    'customer_segmentation_cardholder_sales_amount_with_promo',
    'customer_segmentation_cardholder_sales_amount_without_promo'
];
const DateFilterBetweenTypeSchema = z
    .object({
    start: CustomDateZodSchema,
    end: CustomDateZodSchema
})
    .refine((data) => {
    // Only validate if both dates are present
    if (!data.start || !data.end) {
        return true;
    }
    // Compare dates to ensure start is not after end
    const startDate = new Date(data.start.year, data.start.month - 1, data.start.day);
    const endDate = new Date(data.end.year, data.end.month - 1, data.end.day);
    return startDate <= endDate;
}, {
    message: 'Start date must not be after end date',
    path: ['date_range']
});
const KpiDatePeriodFilterSchema = z.object({
    field: z.enum(DATE_LOOKER_PERIODS),
    value: DateFilterBetweenTypeSchema
});
const NielsenPeriodFilterSchema = z.object({
    field: z.literal(NIELSEN_LOOKER_PERIOD),
    value: NielsenIntervalSchema
});
const KpiPeriodFilterSchema = z.discriminatedUnion('field', [NielsenPeriodFilterSchema, KpiDatePeriodFilterSchema]);
export const KPI_QUERY_SORT_DIRECTION = {
    asc: 'asc',
    desc: 'desc'
};
const KpiQuerySortSchema = z.object({
    field: z.union([z.string(), z.number()]),
    direction: z.enum(Object.values(KPI_QUERY_SORT_DIRECTION))
});
export const KpiQueryFiltersSchema = z.object({
    filters: z.partialRecord(z.enum(KPI_SCOPE_FILTERS), z.string().array()).optional(),
    isWithTax: z.boolean(),
    isMyDataIncluded: z.boolean().optional()
});
const _check = true;
export const KpiQuerySchema = z.object({
    period: KpiPeriodFilterSchema,
    comparisonPeriod: ComparisonPeriodSchema.optional(),
    detentionPeriod: z.nativeEnum(DetentionPeriodValueType).optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
    sort: KpiQuerySortSchema.array().optional(),
    query: KpiQueryFiltersSchema,
    taxonomy: z.enum(PRODUCT_TAXONOMIES),
    storePerimeter: z.enum(STORE_PERIMETERS),
    skipNullValues: z.boolean().optional(),
    sourceContext: z.enum(['projects', 'general']).optional()
});
export const KpiPeriodSchema = z.object({
    name: z.string(),
    granularity: z.enum([...LOOKER_PERIODS, ...PERIOD_EVOLUTIONS])
});
//# sourceMappingURL=kpi.model.js.map